"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { useEffect } from "react";

import { useAlert } from "@saas/shared/feature/alert/alert";
import { AlertDispatch } from "@saas/shared/utils/@interface/alert/alert.interface";
import { notify } from "@saas/shared/utils/alert/alert";
import { emailVerificationStatus } from "@saas/shared/utils/email-verification-status/email-verification-status";

export const useEmailVerificationStatus = () => {
  const searchParams = useSearchParams();
  const router = useRouter();

  const [, dispatch] = useAlert();

  useEffect(() => {
    const verificationStatus = searchParams?.get("verificationStatus");

    if (verificationStatus) {
      handleVerificationStatus(verificationStatus, dispatch);

      // Clean up URL params
      const newParams = new URLSearchParams(searchParams!.toString());
      newParams.delete("verificationStatus");
      router.replace(`?${newParams.toString()}`, { scroll: false });
    }
  }, [dispatch, router, searchParams]);
};

const VERIFICATION_STATUS = {
  [emailVerificationStatus.EXPIRED]: {
    message: "Link verifikasi sudah tidak berlaku, harap kirim ulang.",
    variant: "negative" as const,
  },
  [emailVerificationStatus.VERIFIED]: {
    message: "Verifikasi Email berhasil!",
    variant: "positive" as const,
  },
} as const;

const handleVerificationStatus = (
  status: string,
  dispatch: AlertDispatch
): void => {
  const statusConfig = VERIFICATION_STATUS[status];

  if (statusConfig) {
    notify(dispatch, {
      variant: statusConfig.variant,
      content: statusConfig.message,
      testid: "home__snackbar__link-sent",
    });
  }
};
